import React from 'react';
import {Stack, Grid2, Divider} from "@mui/material";
import { useSelector } from 'react-redux';
import {When} from "react-if";
import Loading from "../../../../../components/loading";
import {RootState} from "../../../../../store";
import {TeamUserActivityTable} from "../../../../../components/team-user-activity-table";
import {TeamUserWeeklyDataTable} from "../../../../../components/team-user-weekly-data-table";
import TeamWeeklyActiveLineChart from "../../../../../components/team-weekly-active-line-chart";


const styles = {
    container: {
        borderRadius: 1,
        border: '0.1px solid #ccc',
        backgroundColor: 'white',
        padding: '3rem 1.5rem 3rem 1.5rem'
    }
};

interface Props{
    onSort?: (sortBy: string, sortOrder: 'ASC' | 'DESC') => void;
    onWeeklySort?: (sortBy: string, sortOrder: 'ASC' | 'DESC') => void;
    currentSortBy?: string;
    currentSortOrder?: 'ASC' | 'DESC';
    currentWeeklySortBy?: string;
    currentWeeklySortOrder?: 'ASC' | 'DESC';
}

export const TeamActivity: React.FC<Props> = ({
                                                  onSort,
                                                  onWeeklySort,
                                                  currentWeeklySortOrder,
                                                  currentWeeklySortBy,
                                                  currentSortBy = 'username',
                                                  currentSortOrder = 'ASC'
                                              }) => {
    const {
        teamUserActivityRecords,
        teamUserWeeklyActivityRecords,
        loading,
    } = useSelector((state: RootState) => state.userActivity);

    return (
        <Stack mt={6}>
            <Grid2 container spacing={5}>
                <Grid2 sx={{...styles.container}} size={{md:12,xs:12,sm:12}}>
                    <TeamUserActivityTable loading={loading?.fetchTeamUserActivityRecords} data={teamUserActivityRecords} onSort = {onSort}  currentSortOrder={currentSortOrder} currentSortBy={currentSortBy} />
                </Grid2>
                <Grid2 sx={{...styles.container}} size={{md:6,xs:12,sm:12}}>
                    <When condition={!loading?.fetchTeamUserWeeklyActivityRecords}>
                        <TeamWeeklyActiveLineChart data={teamUserWeeklyActivityRecords} />
                    </When>
                    <When condition={loading?.fetchTeamUserWeeklyActivityRecords}>
                        <Loading />
                    </When>
                </Grid2>
            </Grid2>
            <Divider sx={{ mt: 3, mb : 3}} />
            <Grid2 container spacing={2}>
                <Grid2 size={{md:12,xs:12,sm:12}}>
                    <TeamUserWeeklyDataTable loading={loading?.fetchTeamUserWeeklyActivityRecords} data={teamUserWeeklyActivityRecords} onSort={onWeeklySort} currentSortBy={currentWeeklySortBy} currentSortOrder={currentWeeklySortOrder}/>
                </Grid2>
            </Grid2>
        </Stack>
    )
}
